import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The browser occasionally reports a benign "ResizeObserver loop completed with
// undelivered notifications" warning when an observed element re-lays-out in the
// same frame. React picks this up and logs it as an uncaught app error. The loop
// originates inside the browser's ResizeObserver implementation (not in app code),
// so suppress just that message app-wide and stop React from surfacing it.
const RO_LOOP_ERROR = "ResizeObserver loop";

window.addEventListener(
  "error",
  (event) => {
    if (event.message && event.message.includes(RO_LOOP_ERROR)) {
      event.stopImmediatePropagation();
    }
  },
  { capture: true }
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    if (event.reason && event.reason.message && event.reason.message.includes(RO_LOOP_ERROR)) {
      event.preventDefault();
    }
  },
  { capture: true }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
